import {useCallback} from "react";
import {FleetAssetCapabilityType} from "@ots-frontend/ots-data";
import {Switch} from "@mantine/core";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {
  BaseFleetAssetCapabilityDataTable,
  BaseFleetAssetCapabilityDataTableProps
} from "./BaseFleetAssetCapabilityDataTable";

export type FleetAssetCapabilityDataTableProps = Omit<BaseFleetAssetCapabilityDataTableProps, 'renderActions'> & {
  permPrefix: string
  selectedCapabilities: Set<FleetAssetCapabilityType>
  toggleCapability: (cap: FleetAssetCapabilityType) => void
}

export const FleetAssetCapabilityDataTable = (props: FleetAssetCapabilityDataTableProps) => {
  const {
    permPrefix,
    selectedCapabilities,
    toggleCapability,
    ...rest
  } = props

  const {hasAccess} = useAuth()

  const renderActions = useCallback((record: FleetAssetCapabilityType, index: number) => {
    return (
      <Switch
        disabled={!hasAccess(`${permPrefix}_edit`)}
        checked={selectedCapabilities.has(record)}
        onChange={() => toggleCapability(record)}
      />
    )
  }, [hasAccess, permPrefix, selectedCapabilities, toggleCapability])

  return (
    <BaseFleetAssetCapabilityDataTable
      {...rest}
      renderActions={renderActions}
    />
  )
}
